import { Button, InputLabel, Tooltip } from "@material-ui/core";
import { buttonsStyle } from "./tables/table";
import { Delete, Visibility } from "@material-ui/icons";
import PreviewDialog from "./dialogs/PreviewDialog";
import { SERVER_URL } from "../../api";


function LogoSection({ labelTitle = "Logo", selectedLogo, setSelectedLogo, objectClass, setObjectClass, openPreviewDialog, setOpenPreviewDialog }) {
    return (
        <div className="mt-2">
            <InputLabel>{labelTitle}</InputLabel>
            <label htmlFor={"upload-media"} className="ml-0 mb-4 mt-1" >
                <input
                    style={{ display: "none" }}
                    id={"upload-media"}
                    name={"upload-media"}
                    type="file"
                    accept={"image/*"}
                    onChange={(e) => {
                        setSelectedLogo(e.target.files[0]);
                    }}
                />
                <Button
                    style={{ marginRight: "15px" }}
                    color="secondary"
                    component="span"
                    variant="outlined"
                >
                    {selectedLogo ||
                        (objectClass.logoURL && objectClass.logoURL !== "")
                        ? "Change media"
                        : "Upload media"}
                </Button>
            </label>
            {(selectedLogo ||
                (objectClass.logoURL && objectClass.logoURL !== "")) && (
                    <>
                        <Tooltip title={"Preview"}>
                            <Button
                                size="small"
                                onClick={() => setOpenPreviewDialog(true)}
                                style={{
                                    ...buttonsStyle,
                                    marginRight: "15px",
                                }}
                            >
                                <Visibility />
                            </Button>
                        </Tooltip>
                        <PreviewDialog
                            title={"Preview"}
                            open={openPreviewDialog}
                            setOpen={setOpenPreviewDialog}
                            file={selectedLogo}
                            src={
                                selectedLogo
                                    ? URL.createObjectURL(selectedLogo)
                                    : `${SERVER_URL}/${objectClass.logoURL}`
                            }
                        />
                        <Tooltip title={"Delete"}>
                            <Button
                                size="small"
                                onClick={() => {
                                    setSelectedLogo(null);
                                    setObjectClass({
                                        ...objectClass,
                                        logoURL: null,
                                    });
                                }}
                            >
                                <Delete />
                            </Button>
                        </Tooltip>
                    </>
                )}
        </div>
    );
}

export default LogoSection;